import React, { useState } from 'react';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  const galleryItems = [
    {
      id: 1,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/dit89hm3_IMG_2906.jpg",
      title: "Širenje i produžavanje obuće",
      description: "Profesionalna oprema za širenje i prilagođavanje obuće"
    },
    {
      id: 2,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/io74nl5w_DSC00445.JPG",
      title: "Popravka patika",
      description: "Profesionalna popravka oštećenih patika i sportske obuće"
    },
    {
      id: 3,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/dtqcfn18_DSC00454.JPG",
      title: "Luksuzne tašne",
      description: "Popravka i restauracija brendiranih tašni"
    },
    {
      id: 4,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/2dc7l7ut_DSC00465.JPG",
      title: "Popravka rančeva",
      description: "Profesionalna popravka i restauracija školskih i putnih rančeva"
    },
    {
      id: 5,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/4uba2mv6_DSC00482.JPG",
      title: "Popravka točkića",
      description: "Zamena i popravka točkića na koferima"
    },
    {
      id: 6,
      image: "https://customer-assets.emergentagent.com/job_majstorska-radionica/artifacts/lplns1on_DSC00476.JPG",
      title: "Rajsferšlusi",
      description: "Popravka i zamena rajsferšlusa na koferima i torbama"
    }
  ];

  return (
    <section id="galerija" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Naši radovi
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-500 to-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Pogledajte primere naših svakodnevnih popravki - od obuće do tašni i kofera
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {galleryItems.map((item) => (
            <div 
              key={item.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer hover:-translate-y-2"
              onClick={() => setSelectedImage(item)}
            >
              {/* Image */}
              <div className="relative h-80 overflow-hidden">
                <img 
                  src={item.image} 
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                
                {/* Title Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white z-10">
                  <h3 className="text-xl font-bold mb-1">{item.title}</h3>
                  <p className="text-sm text-gray-200">{item.description}</p>
                </div>
              </div>

              {/* Hover Border Effect */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-teal-500 rounded-2xl transition-colors pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Info Box */}
        <div className="mt-16 bg-gradient-to-r from-teal-50 to-blue-50 rounded-2xl p-8 border border-teal-100">
          <div className="text-center max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Svaki predmet tretiramo sa posebnom pažnjom
            </h3>
            <p className="text-gray-600 leading-relaxed mb-6">
              Naša misija je da vašim omiljenim predmetima vratimo funkcionalnost i lepši izgled. 
              Od jednostavnih popravki do potpune restauracije - koristimo tradicionalne tehnike i kvalitetne materijale. 
              Rezultat govori sam za sebe - zadovoljstvo naših klijenata je naša najveća nagrada.
            </p>
            <p className="text-teal-600 font-semibold text-lg">
              Preko 50,000 uspešno obnovljenih predmeta!
            </p>
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div 
          className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="absolute top-4 right-4 text-white hover:text-teal-400 transition-colors"
            onClick={() => setSelectedImage(null)}
          >
            <X className="w-8 h-8" />
          </button>
          
          <div className="max-w-4xl w-full">
            <img 
              src={selectedImage.image} 
              alt={selectedImage.title}
              className="w-full h-auto rounded-lg shadow-2xl"
            />
            
            <div className="mt-8 text-center text-white">
              <h3 className="text-2xl font-bold mb-2">{selectedImage.title}</h3>
              <p className="text-gray-300">{selectedImage.description}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
